/**
 * 路由组件出口文件
 */

import Dashboard from './dashboard/Dashboard';
import Enterprise from './management/Enterprise';
import Client from './management/Client';
import User from './management/User';
import AssociateEnterprise from './management/AssociateEnterprise';
import Client_Confirm from './management/Client_Confirm';
import Client_Detail from './management/Client_Detail';
import Enterprise_Edit from './management/Enterprise_Edit';
import AssociateEnterprise_Edit from './management/AssociateEnterprise_Edit';
import User_Edit from './management/User_Edit';
import User_AllEdit from './management/User_AllEdit';
import Department from './management/Department';
import Category from './management/Category';
import Content from './content/Content';
import ContentEdit from './content/ContentEdit';
import Content_AllEdit from './content/Content_AllEdit';
import NotifyManagement from './notify/NotifyManagement';
import NotifyManagement_Edit from './notify/NotifyManagement_Edit';
import PushNotify from './notify/PushNotify';
import PushNotify_Edit from './notify/PushNotify_Edit';
import UserLog from './management/User_Log';
import ContentRead from './content/Content_Read';
import ContentUpload from './content/Content_Upload';
import ContentUserEdit from './content/Content_UserEdit';
import ContentTake from './content/Content_Take';
import TheamWeb from './dashboard/TheamWeb';
import TheamApp from './dashboard/TheamApp';
import ActiveDirectory from './management/ActiveDirectory';
import ActiveDirectoryAdd from './management/ActiveDirectoryAdd';

export default {
    Dashboard, Enterprise, Client,User,AssociateEnterprise,Client_Confirm,Client_Detail,Enterprise_Edit,AssociateEnterprise_Edit,ActiveDirectory,ActiveDirectoryAdd,
    User_Edit,User_AllEdit,Department,Category,Content,NotifyManagement,PushNotify,Content_AllEdit,ContentEdit,
    NotifyManagement_Edit,PushNotify_Edit,UserLog,ContentRead,ContentUpload,ContentUserEdit,ContentTake,TheamWeb,TheamApp
}